export var shouldAlwaysRender = function shouldAlwaysRender(activePage, page, totalPageCount) {
  return page === 1 || activePage === page || page === totalPageCount;
};
export var shouldHidePenultimatePage = function shouldHidePenultimatePage(activePage, pageNum, totalPageCount) {
  return activePage !== totalPageCount || pageNum !== activePage - 1;
};
export var shouldHideSecondPage = function shouldHideSecondPage(activePage, pageNum) {
  return pageNum > 2 || pageNum !== activePage + 1;
};

// constants used in QA testing
export var ARROW_NEXT = 'arrow-next';
export var ARROW_PREV = 'arrow-prev';
export var DESKTOP_NEXT_ELLIPSES = 'ellipses-next-desktop';
export var DESKTOP_PREV_ELLIPSES = 'ellipses-prev-desktop';
export var MOBILE_NEXT_ELLIPSES = 'ellipses-next-mobile';
export var MOBILE_PREV_ELLIPSES = 'ellipses-prev-mobile';
export var NUMBERED_LINK = 'numbered-link';

// constants only used internally
export var DESKTOP = 'desktop';
export var DISTANCE_TO_END_LIMIT = 4;
export var GREATER_THAN_8 = '>8';
export var KEYCODE_ENTER = 13;
export var LOW_PAGE_LIMIT = 8;
export var MID = 'mid';
export var MOBILE = 'mobile';
export var shouldHideInMobile = function shouldHideInMobile(activePage, pageNum, totalPageCount) {
  return !shouldAlwaysRender(activePage, pageNum, totalPageCount) && totalPageCount > DISTANCE_TO_END_LIMIT && shouldHideSecondPage(activePage, pageNum) && shouldHidePenultimatePage(activePage, pageNum, totalPageCount);
};
export var isAboveLowPageLimit = function isAboveLowPageLimit(totalPageCount) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LOW_PAGE_LIMIT;
  return totalPageCount > limit;
};
export var getTotalPageCountKey = function getTotalPageCountKey(totalPageCount) {
  return isAboveLowPageLimit(totalPageCount) ? GREATER_THAN_8 : totalPageCount;
};
export var getActivePageKey = function getActivePageKey(activePage, totalPageCount) {
  var key = activePage;
  if (isAboveLowPageLimit(totalPageCount)) {
    // determine if activePage is a "middle" number
    var activePageBelowLastOverride = activePage <= totalPageCount - DISTANCE_TO_END_LIMIT;
    var activePageAboveFirstOverride = activePage > DISTANCE_TO_END_LIMIT;
    var isMiddleLink = activePageAboveFirstOverride && activePageBelowLastOverride;
    if (isMiddleLink) {
      key = MID;
    }
  }
  return key;
};